import { defineComponent as _defineComponent } from 'vue'
import { normalizeClass as _normalizeClass, createElementVNode as _createElementVNode, unref as _unref, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-16ce363f"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "tab-content" }
const _hoisted_2 = { class: "question-content" }
const _hoisted_3 = ["src"]
const _hoisted_4 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("br", null, null, -1))
const _hoisted_5 = ["textContent"]

import { computed, ref } from "vue";
import tutorial from "@/utils/tutorial";
import { useI18n } from "vue-i18n";


export default /*#__PURE__*/_defineComponent({
  setup(__props) {

const { t } = useI18n();

const tutorialNumber = ref(0);
const currentTutorial = computed(() => tutorial[tutorialNumber.value]);
function increment() {
  if (tutorialNumber.value >= tutorial.length - 1) return;
  tutorialNumber.value++;
}
function decrement() {
  if (tutorialNumber.value <= 0) return;
  tutorialNumber.value--;
}

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("span", {
      class: _normalizeClass({ 'q-nav': true, disabled: tutorialNumber.value <= 0 }),
      onClick: decrement
    }, "◀", 2),
    _createTextVNode(" " + _toDisplayString(_unref(t)("tutorial.tutorial")) + " " + _toDisplayString(tutorialNumber.value + 1) + " ", 1),
    _createElementVNode("span", {
      class: _normalizeClass({
        'q-nav': true,
        disabled: tutorialNumber.value >= _unref(tutorial).length - 1,
      }),
      onClick: increment
    }, "▶", 2),
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("img", {
        src: _unref(currentTutorial).img
      }, null, 8, _hoisted_3),
      _hoisted_4,
      _createElementVNode("p", {
        textContent: _toDisplayString(_unref(t)(_unref(currentTutorial).text))
      }, null, 8, _hoisted_5)
    ])
  ]))
}
}

})